import {APIClient} from '../utils/APIClient';
import {API_URL} from '../settings/local_settings';

/**
 * API de las Guías in-app (Backend: `guides/views.py`). Todas las respuestas usan
 * `{status: 'OK', ...}`; lo que el usuario no puede ver vuelve como 404 uniforme.
 *
 * Los eventos de medición NO pasan por acá: van en lote por `GuidesTracker`.
 */
export class GuidesService {
    static fetchEligible(uiVersion) {
        return new APIClient(API_URL + `guides/eligible/?ui=${encodeURIComponent(uiVersion || '')}`).call('GET');
    }

    static fetchBySlug(slug) {
        return new APIClient(API_URL + `guides/by-slug/${encodeURIComponent(slug)}/`).call('GET');
    }

    static fetchPreview(guideId) {
        return new APIClient(API_URL + `guides/${encodeURIComponent(guideId)}/preview/`).call('GET');
    }

    /**
     * @param payload {version, status, current_step, display_start?, auto?, snooze_days?, screen?, ui?}
     */
    static postState(guideId, payload) {
        return new APIClient(API_URL + `guides/${encodeURIComponent(guideId)}/state/`).call('POST', payload);
    }
}
